import cc from 'classcat';
import { HotspotIconPosition } from '@i-ark/models';
import { hotspotCls, hotspotIconCls } from './LinkHotspot.style.js';
import { jsx } from 'react/jsx-runtime';

const LinkHotspot = ({
  item
}) => {
  return /*#__PURE__*/jsx("a", {
    className: hotspotCls,
    href: item.href,
    target: "_blank",
    rel: "noreferrer",
    children: /*#__PURE__*/jsx("i", {
      className: cc([hotspotIconCls, {
        tl: item.style.icon.position === HotspotIconPosition.TOP_LEFT,
        tr: item.style.icon.position === HotspotIconPosition.TOP_RIGHT,
        bl: item.style.icon.position === HotspotIconPosition.BOTTOM_LEFT,
        br: item.style.icon.position === HotspotIconPosition.BOTTOM_RIGHT
      }])
    })
  });
};

export { LinkHotspot };
//# sourceMappingURL=LinkHotspot.js.map
